// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A7g6L","label":"styles_label__YoDos"};